import { takeLatest, put } from 'redux-saga/effects';
import { massMessage as Api, admin as adminApi } from '../../api';
import { apiSaga } from '../../sagas';
import * as cnt from './store/constants';
function* createMessage(action) {
  yield* apiSaga(cnt.SENDMESSAGE, Api.newMessage, [action.payload]);
}
function* getPartners() {
  yield* apiSaga(cnt.GETPARTNERS, Api.getPartners, []);
}

function* resendBulkMessage({ type, payload }) {
  yield* apiSaga(type, adminApi.resendBulkMessage, [payload]);
}

export const massMessageSagas = [
  takeLatest(cnt.SENDMESSAGE, createMessage),
  takeLatest(cnt.OPENMODAL, getPartners),
  takeLatest('ADMIN_RESEND_BULK_MESSAGE', resendBulkMessage),
];



// WEBPACK FOOTER //
// ./src/app/components/massmessaging/sagas.js